import { render, staticRenderFns } from "./password-validator.vue?vue&type=template&id=c8771ff6&scoped=true"
import script from "./password-validator.vue?vue&type=script&lang=ts"
export * from "./password-validator.vue?vue&type=script&lang=ts"
import style0 from "./password-validator.vue?vue&type=style&index=0&id=c8771ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8771ff6",
  null
  
)

export default component.exports